// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d436ba0","453":"18f82645","667":"2607a657","977":"60b8e728"}[chunkId] + ".chunk.js";
};